import { ReviewLineItem } from "entities/review_request";

export type ReviewMedia = {
  id: number;
  url: string;
  media_type: string;
  thumb_url: string;
};

export type ReviewRequest = {
  id: number;
  status: string;
  sent_at: string | null;
};

export type Review = {
  id: number;
  rating: number;
  title: string;
  body: string;
  reviewer_name: string;
  country_code: string;
  is_verified: boolean;
  source: string;
  email: string;
  customer_name: string;
  order_number: string;
  created_at: string;
  updated_at: string;
  published_at: string | null;
  product_name?: string | null;
  product_sku?: string | null;
  product_image_url?: string | null;
  review_request?: ReviewRequest;
  review_line_item?: ReviewLineItem;
  review_media?: ReviewMedia[];
};

export const RATING_OPTIONS = [
  { value: "1", label: "1 Star" },
  { value: "2", label: "2 Stars" },
  { value: "3", label: "3 Stars" },
  { value: "4", label: "4 Stars" },
  { value: "5", label: "5 Stars" },
];

export const RATING_COLORS: Record<number, string> = {
  1: "red",
  2: "orange",
  3: "yellow",
  4: "lime",
  5: "green",
};

export const VERIFIED_OPTIONS = [
  { value: "true", label: "Verified" },
  { value: "false", label: "Unverified" },
];

export {
  SOURCE_OPTIONS,
  SOURCE_COLORS,
  SOURCE_LABELS,
  type ReviewLineItem,
} from "entities/review_request";
